import { useCallback } from 'react';
export const useScrollToSection = () => {
  return _temp;
};
function _temp(sectionId, t0) {
  const behavior = t0 === undefined ? "smooth" : t0;
  const section = document.getElementById(sectionId);
  if (section) {
    section.scrollIntoView({
      behavior,
      block: "start"
    });
  }
}